import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-0 py-6 sm:px-6 lg:col-span-3 lg:px-0 lg:py-0" }
const _hoisted_2 = { class: "space-y-1 sticky top-20" }
const _hoisted_3 = { class: "truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subNavigation, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.name,
          to: item.href,
          class: _normalizeClass([item.route.includes(_ctx.currentSection) ? 'bg-white text-blue-600 hover:bg-white' : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-3 py-2 text-sm font-medium']),
          "aria-current": item.route.includes(_ctx.currentSection) ? 'page' : undefined
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
              class: _normalizeClass([item.route.includes(_ctx.currentSection) ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 -ml-1 size-6 shrink-0']),
              "aria-hidden": "true"
            }, null, 8, ["class"])),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(item.name)), 1)
          ]),
          _: 2
        }, 1032, ["to", "class", "aria-current"]))
      }), 128))
    ])
  ]))
}